import React, { useState, useMemo } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { scrollToTop } from "@/utils/scrollToTop";

import Loader from "@/components/loader";
import {
	ContactCrawlLocationFragmentParameter, ContactIndustryLocationGroupAndUrl
} from "@/app/pages/contactDirectory/interface";
import { isNotUndefined, isUndefined } from "@/shared/FunctionCore";
import "@/app/pages/contactIndustrySearch/styles/ContactCrawlLocationStyles.scss";
interface ContentLocationProps {
	"contactIndustryLocationGroupAndUrl": ContactIndustryLocationGroupAndUrl;
	"isInitialIfTrueIsMoreIfFalse": boolean;
}

const ContentLocation = (props: ContentLocationProps) => {
	const {
		contactIndustryLocationGroupAndUrl,
		isInitialIfTrueIsMoreIfFalse
	} = props;

	const {
		contactIndustryLocationGroup,
		url
	} = contactIndustryLocationGroupAndUrl;

	const { count } = contactIndustryLocationGroup;

	const contactIndustryLocationGroupLocation = contactIndustryLocationGroup.location;
	const link = "/contact-directory/contact-industry-search" + url.replace("/content/dnb-us/en/home", "")
		+ ".html";

	return (
		<li className={classnames({
			"crawl-loc-list-comp-flex": true,
			"initial-info": isInitialIfTrueIsMoreIfFalse,
			"more-info": !isInitialIfTrueIsMoreIfFalse
		})}>
			<Link
				className="crawl-loc-anchor-text"
				to={link}
				onClick={scrollToTop}
			>
				{contactIndustryLocationGroupLocation}
			</Link>

			<span className="crawl-loc-number-text">
				&nbsp;

				(
				{count}
				)
			</span>
		</li>
	);
};

type ContactCrawlLocationFragmentComponentProps = ContactCrawlLocationFragmentParameter;

const ContactCrawlLocation = (props: ContactCrawlLocationFragmentComponentProps): JSX.Element => {
	const {
		locationGroups,
		locationMetaInformation,
		showLocationFailure,
		isLoading
	} = props;

	const industryTitle = locationMetaInformation?.industryTitle;
	// const naics = locationMetaInformation?.naics;

	const [isShowMore, setIsShowMore] = useState(false);

	const headerText = useMemo(() => {
		if (locationMetaInformation?.addressRegion) {
			return " Town";
		} if (locationMetaInformation?.addressCountry) {
			return " State/Province";
		} if (isUndefined(locationMetaInformation?.addressCountry)) {
			return " Country/Region";
		}
	}, [locationMetaInformation])

	const content =
		() => isNotUndefined(locationMetaInformation) && locationGroups?.length > 0 ? (
			<div className="crawl-loc-component-container">
				<h3 className="crawl-loc-header-text">
					{industryTitle}

					{" "}

					Contacts in this
					{headerText}
				</h3>

				<ul className="crawl-loc-flex-component">
					{locationGroups.map((co, nu) => {
						const initialIfTrueIsMoreIfFalse = nu < 32;

						if (!initialIfTrueIsMoreIfFalse && !isShowMore) {
							return <></>;
						}

						return <ContentLocation
							contactIndustryLocationGroupAndUrl={co}
							isInitialIfTrueIsMoreIfFalse={initialIfTrueIsMoreIfFalse}
							key={nu}
						/>;
					})}
				</ul>

				{locationGroups.length > 32 ? (
					<button
						className="crawl-loc-button-text"
						onClick={() => setIsShowMore((bo) => !bo)}
						type="button">
						{
							isShowMore
								? "Show Less"
								: "Show More"
						}

						<i className={isShowMore ? "up-arrow" : "down-arrow"} />
					</button>
				) : (
					<></>
				)}
			</div>
		) : (
			<></>
		);

	return (
		<>
			{showLocationFailure ? (
				<div className="container">
					<div className="crawl-loc-delay-response">
						We could not load these results at this time
					</div>
				</div>
			) : (!isLoading ? (
				<div className="crawl-loc-bg-image">
					<div className="container">
						{content()}
					</div>
				</div>
			) : <Loader inProgress={isLoading} />
				// (
				// 	<div className="amp-gif1">
				// 		<div className="loaderGifWrapper">
				// 			<div className="loaderGif" />
				// 		</div>
				// 	</div>
				// )
			)}
		</>
	);
};

export default ContactCrawlLocation;
